import { Variant } from '@kizi/core-components';

const H1: Variant = {
  color: 'heading',
  fontFamily: 'heading',
  fontSize: [6, 7],
  fontWeight: 1,
  lineHeight: 0,
};

const H2: Variant = {
  ...H1,
  fontSize: [5, 6],
  lineHeight: [2, 1],
  my: 6,
};

const H3: Variant = {
  ...H1,
  fontSize: [4, 5],
  lineHeight: 2,
};

const H4: Variant = {
  ...H1,
  fontSize: [3, 4],
  lineHeight: 2,
};

const H4Disabled: Variant = {
  ...H1,
  fontSize: [3, 4],
  lineHeight: 2,
  color: 'disabled',
};

const H5: Variant = {
  ...H1,
  fontSize: [2, 3],
  lineHeight: 2,
};

const H6: Variant = {
  ...H1,
  fontSize: [1, 2],
  lineHeight: 2,
};

const timeOfDelivery: Variant = {
  ...H4,
  borderTop: '1px solid',
  borderTopColor: 'second.1',
  mb: 4,
  mt: 0,
  pt: 6,
};

const headingVariants = { H1, H2, H3, H4, H4Disabled, H5, H6, timeOfDelivery };

export default headingVariants;
